// extracted by mini-css-extract-plugin
module.exports = {"button":"tableButton_button__11DJJ"};